var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.section)?_c('router-view',{attrs:{"configuration":_vm.section.props.configuration,"material-type":_vm.materialType,"section":_vm.section}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }